import React from 'react';
import {Button} from 'react-bootstrap';
import PDFLinkViewer from './PDFViewer';
import {saveByteArray_getUrl, base64ToArrayBuffer} from '../../utils/utilities';

class PDFLink extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            count: 0,
        }
        this.handleNextPdf = this.handleNextPdf.bind(this);
        this.handlePrevPdf = this.handlePrevPdf.bind(this);
    }
handleNextPdf = () => {
    let count = this.state.count;
    count++;
    this.setState({count})
}
handlePrevPdf = () => {
    let count = this.state.count;
    count--;
    this.setState({count})
}
render() {
        const data = this.props.pdfLink;
        var url = '';
       const arr=[];
        if (data) {
        data.split(',').forEach((file) => {
                    const fileArray = file.split('_');
                    url = saveByteArray_getUrl(base64ToArrayBuffer(fileArray[0]), fileArray[1]);
                    arr.push(url);
                })
        }
        var len=arr.length;
        return (
            <div>
        <div className="rght-btn">
        {this.state.count!=len-1&& len==2 && url && <Button onClick={this.handleNextPdf}> Next </Button>}
        {this.state.count>0 && <Button onClick={this.handlePrevPdf}> Previous </Button>}
        </div>
        {<PDFLinkViewer
                count={this.state.count}
                url={arr[this.state.count]}
           handleNextPdf={this.handleNextPdf}
        handlePrevPdf={this.handlePrevPdf} />}
            </div>
 )
}
}
export default PDFLink;

